/* tu-sort.js -- the Sort dropdown (snippets/tu-sort.liquid) on collection
 * and search pages. Loaded from layout/theme.liquid so both pages get it;
 * the previous <select> handler lived in tu-collection's section script,
 * which never ran on the search page (Shopify only runs a section's script
 * when that section is on the page), so sorting search results did nothing.
 *
 * Open/close with the button, click outside, Escape (refocuses the button),
 * ArrowUp/Down/Home/End walk the options, Enter/Space or click picks one.
 * Picking sets ?sort_by= on the current URL, keeps every filter param,
 * drops ?page= and navigates. */
(function () {
  var OPEN = 'is-open';

  function items(root) { return Array.prototype.slice.call(root.querySelectorAll('[data-tu-sort-option]')); }

  function open(root) {
    if (root.classList.contains(OPEN)) return;
    closeAll();
    root.classList.add(OPEN);
    root.querySelector('.tu-sort__btn').setAttribute('aria-expanded', 'true');
    var sel = root.querySelector('[aria-selected="true"]') || items(root)[0];
    if (sel) sel.focus();
  }
  function close(root, refocus) {
    if (!root.classList.contains(OPEN)) return;
    root.classList.remove(OPEN);
    var btn = root.querySelector('.tu-sort__btn');
    btn.setAttribute('aria-expanded', 'false');
    if (refocus) btn.focus();
  }
  function closeAll() { document.querySelectorAll('[data-tu-sort].' + OPEN).forEach(function (r) { close(r, false); }); }

  function pick(root, li) {
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', li.getAttribute('data-tu-sort-option'));
    url.searchParams.delete('page');
    var v = root.querySelector('[data-tu-sort-value]');
    if (v) v.textContent = li.textContent.trim();
    close(root, false);
    window.location.assign(url.toString());
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.tu-sort__btn');
    if (btn) {
      var root = btn.closest('[data-tu-sort]');
      root.classList.contains(OPEN) ? close(root, false) : open(root);
      return;
    }
    var li = e.target.closest('[data-tu-sort-option]');
    if (li) { e.preventDefault(); pick(li.closest('[data-tu-sort]'), li); return; }
    if (!e.target.closest('[data-tu-sort]')) closeAll();
  });

  document.addEventListener('keydown', function (e) {
    var root = e.target.closest && e.target.closest('[data-tu-sort]');
    if (!root) return;
    var list = items(root);
    var i = list.indexOf(document.activeElement);
    switch (e.key) {
      case 'Escape': close(root, true); e.preventDefault(); break;
      case 'ArrowDown':
        e.preventDefault();
        if (!root.classList.contains(OPEN)) { open(root); break; }
        (list[Math.min(i + 1, list.length - 1)] || list[0]).focus(); break;
      case 'ArrowUp':
        e.preventDefault();
        (list[Math.max(i - 1, 0)] || list[0]).focus(); break;
      case 'Home': e.preventDefault(); list[0] && list[0].focus(); break;
      case 'End': e.preventDefault(); list[list.length - 1] && list[list.length - 1].focus(); break;
      case 'Enter': case ' ':
        if (i >= 0) { e.preventDefault(); pick(root, list[i]); }
        break;
      case 'Tab': close(root, false); break;
    }
  });

  document.addEventListener('focusin', function (e) {
    document.querySelectorAll('[data-tu-sort].' + OPEN).forEach(function (r) {
      if (!r.contains(e.target)) close(r, false);
    });
  });
})();
